import { BaseApiService } from "./BaseApiService";
import { DateRangeResponse, ICalendarService } from "@shared/mirage/services/ICalendarService";
import dayjs from "dayjs";

export class CalendarService extends BaseApiService implements ICalendarService {
    constructor() {
        super("mirage/calendar");
    }
    async resolveNamedRange(range: string): Promise<DateRangeResponse> {
        const queryRange = range.replace(/ /gi, "_");
        const resp = await this.httpInstance().get("/resolveRange/" + queryRange);
        return resp.data;
    }

    async addBusinessDays(date: Date, days: number): Promise<Date | null> {
        const request = { date, days };
        const response = await this.httpInstance().post("/addBusinessDays", request);
        const isValidDate = dayjs(response.data).isValid();
        if (!isValidDate) {
            return null;
        }
        return response.data;
    }
}
